module.exports = __webpack_public_path__ + "static/media/40.a3c9f3ba.jpg";